import { render } from "./error-detail.vue?vue&type=template&id=05c397c1&scoped=true"
import script from "./error-detail.vue?vue&type=script&lang=js"
export * from "./error-detail.vue?vue&type=script&lang=js"

import "./error-detail.vue?vue&type=style&index=0&id=05c397c1&scoped=true&lang=css"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c397c1"]])

export default __exports__